import { computed, inject, Injectable, Signal } from '@angular/core';
import { ProductCategory, ProductListItemDTO, ProductManagementControllerService } from '@iota/inh-core-v1-management-client';
import { createAsyncResource } from '../utils/async-state.util';

/** App-wide cache: the first `load()` fetches the list, every later one is a no-op. */
@Injectable({ providedIn: 'root' })
export class ProductListService {
    private readonly productApi = inject(ProductManagementControllerService);
    private readonly resource = createAsyncResource(() => this.productApi.findAll(), { lazy: true });

    readonly data = this.resource.data;
    readonly loading = this.resource.loading;
    readonly error = this.resource.error;
    readonly requested = this.resource.requested;

    readonly mockBasketProductExists = computed(() =>
        (this.data() ?? []).some((product) => product.productCategory === ProductCategory.MOCK_BASKET_PRODUCT)
    );

    load(): void {
        this.resource.load();
    }

    reload(): void {
        this.resource.reload();
    }

    byVendorId(vendorId: string): Signal<ProductListItemDTO[]> {
        return computed(() => (this.data() ?? []).filter((product) => product.vendorId === vendorId));
    }
}
